module.exports = __webpack_public_path__ + "img/michael.a7790ecb.jpeg";